<template>
  <el-dialog custom-class="medium-dialog" title="找镜架" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <el-select v-model="categorycode" placeholder="" style="width:100px" @change="init">
          <el-option label="镜架" value="002"></el-option>
          <el-option label="太阳镜" value="003"></el-option>
        </el-select>
        <el-select v-model="pingpai" multiple filterable  remote reserve-keyword placeholder="请输入品牌" style="width: 680px"
          :remote-method="pingpaiMethod" :loading="loading" @change="maxNum(pingpai)">
          <el-option  v-for="item in pingpaList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-col>
      <el-col :span="24" class="toobar" v-if="pingpai.length>0&&pingpai.length<6">
        <el-select v-model="model" multiple filterable  remote reserve-keyword placeholder="请输入型号" style="width: 680px" @change="maxNum(model)"
                   :remote-method="modelMethod" :loading="loading">
          <el-option  v-for="item in modelList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="search" v-if="model.length>0&&model.length<6">搜索</el-button>
      </el-col>
      <el-table
        :data="tableData"
        size="mini"
        border
        style="width: 100%;">
        <el-table-column label="门店"  align="left" header-align="center" width="140" prop="tenantid">
        </el-table-column>
        <el-table-column label="名称"  align="left" header-align="center" prop="seedname">
        </el-table-column>
        <el-table-column label="编码" align="left" header-align="center" width="140" prop="seedcode">
        </el-table-column>
        <el-table-column label="型号" align="left" header-align="center" width="100" >
          <template slot-scope="scope">
            {{getPackagesize(scope.row.packagesize,'M')}}
          </template>
        </el-table-column>
        <el-table-column label="色号" align="left" header-align="center" width="100" >
          <template slot-scope="scope">
            {{getPackagesize(scope.row.packagesize,'C')}}
          </template>
        </el-table-column>
        <el-table-column label="数量" align="left" header-align="center" width="100" prop="subtractnum">
        </el-table-column>

      </el-table>
    </div>
  </el-dialog>
</template>

<script>
  import {wholesearchmodel,wholesearchname} from '@/api/set/jxcgoodscategory';
  import {getWholeFramestore} from '@/api/set/jxcresultstore';

  export default {
    name: "Findframe",
    data() {
      return {
        tableData: [],
        pingpai: [],
        pingpaList:[],
        pingpaData:[],
        model:[],
        modelList:[],
        modelData:[],
        loading: false,
        categorycode: '',
        dialogFormVisible: false,
      }
    },
    methods: {
      maxNum(value){
        if(value.length>5){
          this.$message({
            message: '最多只能选中5条记录！',
            type: 'error'
          })
        }
      },
      getPackagesize(packagesize,coloum){
        try{
          return JSON.parse(packagesize)[coloum];
        }catch (e) {}
        return '';
      },
      show() {
        this.dialogFormVisible = true
        this.categorycode = '002'
        this.init();
      },
      pingpaiMethod(query) {
        if (query !== '') {
          this.loading = true;
          this.pingpai=[];
          this.pingpaList = [];
          wholesearchname({categorycode: this.categorycode, categoryname: query}).then(response => {
            this.loading = false;
            this.pingpaData = response.data.obj;
            for (let i in this.pingpaData) {
              if (this.pingpaList.indexOf(this.pingpaData[i].categoryname) == -1) {
                this.pingpaList.push(this.pingpaData[i].categoryname);
              }
            }
          });
        }
      },
      modelMethod(query) {
        if (query !== ''&&query.length>1) {
          this.loading = true;
          this.model = [];
          this.modelList = [];
          var arr = [];
          for (let i in this.pingpai) {
            var name = this.pingpai[i];
            for (let j in this.pingpaData) {
              if (this.pingpaData[j].categoryname == name) {
                arr.push({tenantid: this.pingpaData[j].tenantid, categorycode: this.pingpaData[j].categorycode});
              }
            }
          }
          if(arr.length==0) return;
          wholesearchmodel({catestr: JSON.stringify(arr), model: query}).then(response => {
            this.loading = false;
            this.modelData = response.data.obj;
            for (let i in this.modelData) {
              if (this.modelList.indexOf(this.modelData[i].sname) == -1) {
                this.modelList.push(this.modelData[i].sname);
              }
            }
          });
        }
      },
      search() {
        var arr = [];
        for (let i in this.model) {
          var name = this.model[i];
          for (let j in this.modelData) {
            if (this.modelData[j].sname == name) {
              arr.push({seedcode: this.modelData[j].seedcode, tenantid: this.modelData[j].tenantid});
            }
          }
        }
        this.tableData = [];
        if (arr.length == 0) return;
        getWholeFramestore({goodsstr: JSON.stringify(arr)}).then(response => {
          if (response.data.code == 0) {
            this.tableData = response.data.obj;
          }
        });
      },
      init() {
        this.pingpai = []
        this.pingpaList = [];
        this.pingpaData = [];
        this.model = [];
        this.modelList = [];
        this.modelData = [];
        this.tableData = [];
      },
    },
    mounted() {
    },
    components: {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/testorder/warehouse/Findframe.vue